import axios from "axios";
import APIURL from "../../../Main/apiurl";

const getAuthConfig = () => {
  const token = localStorage.getItem("user");
  if (!token) {
    localStorage.clear();
    window.location.href = "/";
    throw new Error("Authentication required");
  }
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
};

const getAccountBalances = async () => {
  try {
    const config = getAuthConfig();

    const response = await axios.get(`${APIURL}/accounts/balances`, {
      config,
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching account balances:",
      error.response?.data || error.message
    );
    return { success: false, message: "Failed to fetch account balances" };
  }
};

const getLedgerEntries = async (data) => {
  try {

    const config = getAuthConfig();
    const response = await axios.post(`${APIURL}/transactions`, data, config);

    return response.data;
  } catch (error) {
    console.error(
      "Error fetching ledger transactions:",
      error.response?.data || error.message
    );
    return { success: false, message: "Failed to fetch ledger transactions" };
  }
};

export { getAccountBalances, getLedgerEntries };
